<div style="position: relative;">

  <p> <iframe width="700px" height="385px" [src]="urlSafe" frameborder="0"
      style="margin-left: -40px !important; margin-top: -34px !important; margin-bottom: -47px !important; "
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
    </iframe>
  </p>

</div>